export function objectToGetParams(obj) {
  let result = "";
  for (const key in obj) {
    result += `${key}=${obj[key]}&`;
  }
  result = result.substr(0, result.length - 1);
  return result;
}

// 获取url上的query对象
export function param2Obj(url) {
  if (typeof url !== "undefined") {
    const _url = url.split("?");
    if (_url.length > 1) {
      url = _url[1]; // 从起始索引号提取字符串中指定数目的字符
      const arr = url.split("&"); // 把字符串分割为字符串数组
      const obj = {};
      let newarr = [];
      arr.forEach((v) => {
        // 数组遍历
        newarr = v.split("=");
        if (typeof obj[newarr[0]] === "undefined") {
          obj[newarr[0]] = newarr[1];
        }
      });
      return obj;
    }
    return {};
  }
}
